import {gql} from "@apollo/client";
import {useMutation} from "@apollo/client";
import {FsoSupportInput} from "../../domain";

const SUBMIT_FSO_SUPPORT = gql`
mutation SubmitFsoSupportForAtRiskItems($authItemGuids: [UUID!]!, $input: FsoSupportInput!) {
  submitFsoSupportForAtRiskItems(authItemGuids: $authItemGuids, input: $input) {
    guid
    string
    offeredHoursStatus
    status
    startDate
    endDate
    procedureCode
    modifier
    practitionerRole
    tier
    minimumHoursAuthorized
    maximumHoursAuthorized
    hoursBilled
    directCareHoursRequired
    dateAtRiskPublished
    atRiskResponseDueDate
    atRiskResponseDate
    atRiskResponseReasons
    lastModifiedDate
    lastModifiedBy
    submitterGuid
  }
}
`;

export function useSubmitFsoSupport() {
    const [submitFsoSupport, {loading, error}] = useMutation(SUBMIT_FSO_SUPPORT);
    
    const execute = async (authItemGuids: string[], data: FsoSupportInput) => {
        const result = await submitFsoSupport({
            variables: {
                authItemGuids,
                input: {
                    relatedToBilling: data.relatedToBilling,
                    confirmedWithBilling: data.confirmedWithBilling,
                    billingRejectionsCorrected: data.billingRejectionsCorrected,
                    fsoInquiry: data.fsoInquiry
                }
            }
        });
        
        return result.data?.submitFsoSupportForAtRiskItems;
    };
    
    return {
        submitFsoSupport: execute,
        loading,
        error
    };
}
